import { createAsyncThunk } from "@reduxjs/toolkit";

import { InternalAuthService } from "Auth/services";
import { AUTH_ACTIONS, IUserPatchData } from "Auth/types";

export const editUser = createAsyncThunk(
  AUTH_ACTIONS.editUser,
  async (
    {
      userId,
      editUserData,
    }: {
      userId: string;
      editUserData: IUserPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      if (userId) {
        const editedUser = await InternalAuthService.editUser(userId, editUserData);

        return editedUser;
      }

      return null;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
